module.exports = __webpack_public_path__ + "assets/fbe73def9643a5662c23e23ab3680ce0.mp3";